/**
 * SNCKD. — Signature Box Builder
 * 5 Custom-Dropdown-Felder mit Vorschaubild pro Sorte
 * Überträgt Auswahl als Bestelleigenschaften an den Warenkorb
 */

(function () {
  'use strict';

  class SnckdBoxBuilder extends HTMLElement {
    connectedCallback() {
      this.render();
      this.bindEvents();
    }

    get slots() {
      return parseInt(this.getAttribute('slots') || '5', 10);
    }

    render() {
      let products = [];
      try {
        products = JSON.parse(this.getAttribute('data-products') || '[]');
      } catch (e) {}

      if (!products.length) return;

      const first = products[0];
      const rows = Array.from({ length: this.slots }, (_, i) => this._buildRow(i + 1, products, first));

      this.innerHTML = `
        <div class="snckd-builder">
          <div class="snckd-builder__intro">
            <div class="snckd-builder__label">Sortenauswahl</div>
            <div class="snckd-builder__subtitle">Wähle deine ${this.slots} Lieblingssorten</div>
          </div>

          ${rows.join('')}

          <div class="snckd-builder__progress">
            <div class="snckd-builder__progress-top">
              <span class="snckd-builder__progress-count"><strong id="snckd-filled">${this.slots}</strong> / ${this.slots} Sorten gewählt</span>
              <span class="snckd-builder__progress-status" id="snckd-status">Box vollständig ✓</span>
            </div>
            <div class="snckd-builder__bar">
              <div class="snckd-builder__bar-fill" id="snckd-bar-fill" style="width:100%"></div>
            </div>
          </div>

          <div id="snckd-properties"></div>
        </div>
      `;

      this.injectStyles();
    }

    _buildRow(slot, products, firstProduct) {
      const hiddenOptions = products.map((p, i) => `
        <option value="${this._escape(p.title)}" data-image="${this._escape(p.featured_image || '')}" data-handle="${this._escape(p.handle || '')}" ${i === 0 ? 'selected' : ''}>
          ${this._escape(p.title)}
        </option>
      `).join('');

      const customOptions = products.map((p, i) => `
        <li class="snckd-custom-select__option${i === 0 ? ' is-selected' : ''}"
            data-value="${this._escape(p.title)}"
            data-image="${this._escape(p.featured_image || '')}"
            role="option"
            aria-selected="${i === 0 ? 'true' : 'false'}">
          <img src="${this._escape(p.featured_image || '')}" alt="${this._escape(p.title)}" width="40" height="40" loading="lazy">
          <span>${this._escape(p.title)}</span>
        </li>
      `).join('');

      return `
        <div class="snckd-builder__row" data-slot="${slot}">
          <div class="snckd-builder__num">${String(slot).padStart(2, '0')}</div>
          <div class="snckd-builder__select-wrap">
            <select class="snckd-dropdown" data-slot="${slot}" aria-hidden="true" tabindex="-1" style="display:none">
              ${hiddenOptions}
            </select>
            <div class="snckd-custom-select" data-slot="${slot}" tabindex="0" role="combobox" aria-expanded="false" aria-label="Sorte ${slot}">
              <div class="snckd-custom-select__trigger">
                <img class="snckd-custom-select__thumb" src="${this._escape(firstProduct.featured_image || '')}" alt="${this._escape(firstProduct.title)}" width="36" height="36">
                <span class="snckd-custom-select__label">${this._escape(firstProduct.title)}</span>
                <svg class="snckd-custom-select__arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#888888" stroke-width="1.5" stroke-linecap="square"/>
                </svg>
              </div>
              <ul class="snckd-custom-select__list" role="listbox">
                ${customOptions}
              </ul>
            </div>
          </div>
        </div>
      `;
    }

    bindEvents() {
      if (!this.querySelectorAll) return;

      // Native selects triggern updateAll (bleibt unverändert)
      this.querySelectorAll('.snckd-dropdown').forEach(dropdown => {
        dropdown.addEventListener('change', () => this.updateAll());
      });

      // Custom Dropdowns
      this.querySelectorAll('.snckd-custom-select').forEach(cs => {
        const trigger = cs.querySelector('.snckd-custom-select__trigger');

        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = cs.classList.contains('is-open');
          this.querySelectorAll('.snckd-custom-select.is-open').forEach(other => {
            if (other !== cs) this._closeSelect(other);
          });
          isOpen ? this._closeSelect(cs) : this._openSelect(cs);
        });

        cs.querySelectorAll('.snckd-custom-select__option').forEach(opt => {
          opt.addEventListener('click', (e) => {
            e.stopPropagation();
            this._selectOption(cs, opt);
            this._closeSelect(cs);
          });
        });

        cs.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            cs.classList.contains('is-open') ? this._closeSelect(cs) : this._openSelect(cs);
          } else if (e.key === 'Escape') {
            this._closeSelect(cs);
            cs.focus();
          } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (!cs.classList.contains('is-open')) this._openSelect(cs);
            this._navigateOptions(cs, e.key === 'ArrowDown' ? 1 : -1);
          }
        });
      });

      // Klick außerhalb schließt alle
      document.addEventListener('click', () => {
        this.querySelectorAll('.snckd-custom-select.is-open').forEach(cs => this._closeSelect(cs));
      });

      this.updateAll();
    }

    _openSelect(cs) {
      cs.classList.add('is-open');
      cs.setAttribute('aria-expanded', 'true');
    }

    _closeSelect(cs) {
      cs.classList.remove('is-open');
      cs.setAttribute('aria-expanded', 'false');
    }

    _selectOption(cs, opt) {
      const slot    = cs.getAttribute('data-slot');
      const value   = opt.getAttribute('data-value');
      const image   = opt.getAttribute('data-image');
      const label   = opt.querySelector('span').textContent.trim();

      // Custom-Select-UI aktualisieren
      cs.querySelectorAll('.snckd-custom-select__option').forEach(o => {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-selected', 'true');

      const thumb   = cs.querySelector('.snckd-custom-select__thumb');
      const labelEl = cs.querySelector('.snckd-custom-select__label');
      if (thumb && image) { thumb.src = image; thumb.alt = label; }
      if (labelEl) labelEl.textContent = label;

      // Verstecktes Select synchronisieren → löst updateAll() aus
      const select = this.querySelector(`.snckd-dropdown[data-slot="${slot}"]`);
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _navigateOptions(cs, dir) {
      const options = Array.from(cs.querySelectorAll('.snckd-custom-select__option'));
      const current = cs.querySelector('.snckd-custom-select__option.is-selected');
      const idx     = options.indexOf(current);
      const next    = options[Math.max(0, Math.min(options.length - 1, idx + dir))];
      if (next) this._selectOption(cs, next);
    }

    updateAll() {
      const dropdowns = this.querySelectorAll('.snckd-dropdown');
      const propsContainer = this.querySelector('#snckd-properties');
      if (!propsContainer) return;

      // Hidden inputs für Warenkorb-Eigenschaften
      propsContainer.innerHTML = '';
      dropdowns.forEach((dropdown, idx) => {
        if (dropdown.value) {
          const input = document.createElement('input');
          input.type  = 'hidden';
          input.name  = `properties[Sorte ${idx + 1}]`;
          input.value = dropdown.value;
          propsContainer.appendChild(input);

          // Handle als versteckte Property (_handle_N) für Cart-Vorschau
          const selectedOption = dropdown.options[dropdown.selectedIndex];
          const handle = selectedOption ? selectedOption.getAttribute('data-handle') : '';
          if (handle) {
            const handleInput = document.createElement('input');
            handleInput.type  = 'hidden';
            handleInput.name  = `properties[_handle_${idx + 1}]`;
            handleInput.value = handle;
            propsContainer.appendChild(handleInput);
          }
        }
      });

      // Fortschrittsbalken
      const filled  = Array.from(dropdowns).filter(d => d.value).length;
      const total   = dropdowns.length;
      const pct     = Math.round((filled / total) * 100);
      const bar     = this.querySelector('#snckd-bar-fill');
      const countEl = this.querySelector('#snckd-filled');
      const status  = this.querySelector('#snckd-status');

      if (bar)     bar.style.width = pct + '%';
      if (countEl) countEl.textContent = filled;
      if (status) {
        if (filled === total) {
          status.textContent = 'Box vollständig ✓';
          status.style.color = '#E6007D';
        } else {
          status.textContent = `Noch ${total - filled} Sorte${total - filled !== 1 ? 'n' : ''} wählen`;
          status.style.color = '#888';
        }
      }
    }

    _escape(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    injectStyles() {
      if (document.getElementById('snckd-builder-styles')) return;
      const style = document.createElement('style');
      style.id = 'snckd-builder-styles';
      style.textContent = `
        .snckd-builder {
          margin-top: 28px;
          padding-top: 28px;
          border-top: 1px solid rgba(255,255,255,0.08);
        }
        .snckd-builder__intro { margin-bottom: 20px; }
        .snckd-builder__label {
          font-family: 'JetBrains Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: #E6007D;
          margin-bottom: 6px;
        }
        .snckd-builder__subtitle {
          font-size: 14px;
          color: #888;
          font-family: 'Inter', sans-serif;
        }
        .snckd-builder__row {
          display: grid;
          grid-template-columns: 32px 1fr;
          gap: 14px;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .snckd-builder__num {
          font-family: 'JetBrains Mono', monospace;
          font-size: 20px;
          color: #E6007D;
          letter-spacing: 0.1em;
        }
        .snckd-builder__select-wrap {
          position: relative;
          min-width: 0;
        }

        /* ── Custom Select ── */
        .snckd-custom-select {
          position: relative;
          width: 100%;
          user-select: none;
          outline: none;
        }
        .snckd-custom-select__trigger {
          display: flex;
          align-items: center;
          gap: 12px;
          height: 58px;
          padding: 0 14px;
          background-color: #0A0A0A;
          background-image: linear-gradient(140deg, rgba(230,0,125,0.15), rgba(230,0,125,0) 60%);
          border: 1px solid rgba(230,0,125,0.25);
          cursor: pointer;
          transition: border-color 0.15s;
        }
        .snckd-custom-select:focus .snckd-custom-select__trigger,
        .snckd-custom-select.is-open .snckd-custom-select__trigger {
          border-color: #E6007D;
          outline: none;
        }
        .snckd-custom-select__thumb {
          width: 36px; height: 36px;
          object-fit: cover;
          flex-shrink: 0;
        }
        .snckd-custom-select__label {
          flex: 1;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
        }
        .snckd-custom-select__arrow {
          flex-shrink: 0;
          transition: transform 0.2s ease;
        }
        .snckd-custom-select.is-open .snckd-custom-select__arrow {
          transform: rotate(180deg);
        }

        /* ── Dropdown-Liste ── */
        .snckd-custom-select__list {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          z-index: 200;
          list-style: none;
          margin: 0;
          padding: 0;
          background: #0A0A0A;
          border: 1px solid rgba(230,0,125,0.25);
          border-top: none;
          max-height: 260px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #333 #0A0A0A;
        }
        .snckd-custom-select__list::-webkit-scrollbar { width: 4px; }
        .snckd-custom-select__list::-webkit-scrollbar-track { background: #0A0A0A; }
        .snckd-custom-select__list::-webkit-scrollbar-thumb { background: #333; }
        .snckd-custom-select.is-open .snckd-custom-select__list {
          display: block;
        }

        /* ── Option ── */
        .snckd-custom-select__option {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          cursor: pointer;
          border-bottom: 1px solid rgba(255,255,255,0.04);
          transition: background 0.1s;
        }
        .snckd-custom-select__option:last-child { border-bottom: none; }
        .snckd-custom-select__option:hover {
          background: rgba(230,0,125,0.1);
        }
        .snckd-custom-select__option.is-selected {
          background: rgba(230,0,125,0.08);
          border-left: 2px solid #E6007D;
          padding-left: 12px;
        }
        .snckd-custom-select__option img {
          width: 40px; height: 40px;
          object-fit: cover;
          flex-shrink: 0;
        }
        .snckd-custom-select__option span {
          flex: 1;
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
        }

        /* ── Fortschritt ── */
        .snckd-builder__progress {
          margin-top: 24px;
          padding-top: 20px;
        }
        .snckd-builder__progress-top {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          margin-bottom: 10px;
          font-family: 'Inter', sans-serif;
        }
        .snckd-builder__progress-count { color: #888; }
        .snckd-builder__progress-count strong { color: #fff; }
        .snckd-builder__progress-status { color: #E6007D; font-weight: 600; }
        .snckd-builder__bar {
          width: 100%; height: 4px;
          background: rgba(255,255,255,0.08);
          overflow: hidden;
        }
        .snckd-builder__bar-fill {
          height: 100%;
          background: #E6007D;
          transition: width 0.3s ease;
        }

        @media (max-width: 480px) {
          .snckd-builder__row { grid-template-columns: 28px 1fr; gap: 10px; }
          .snckd-custom-select__trigger { height: 52px; }
        }
      `;
      document.head.appendChild(style);
    }
  }

  customElements.define('snckd-box-builder', SnckdBoxBuilder);
})();
